import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { IoReload } from 'react-icons/io5'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import { GlobalContext } from '../../../App'
import { useModal } from '../../../components/Utils/UseModal'
import ModalConfirmacao from '../../utils/modal/ModalConfirmacao'
import PrimeTable from '../../../components/PrimeTable'

const AplicacaoMedicamento = () => {
  const { usuarioLogado } = useContext(GlobalContext)

  const openModal = useModal(ModalConfirmacao)

  const [atualiza, setAtualiza] = useState(false)
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
    setAtualiza((v) => !v)
  }, [])

  const exclui = (empresa) => async (e) => {
    e.stopPropagation()
    if (
      !(await openModal({
        titulo: `Mas você tem CERTEZA que deseja ${empresa[14] ? 'ativar' : 'excluir'} ${empresa[2]} ?`,
      }))
    )
      return
    await metodoPrograma('exclui', { idEmpresa: empresa[0] })
    setAtualiza((v) => !v)
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela, voltar])

  return (
    <Programa codigo="CtrlAplicacaoMedicamento" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              action="lista"
              codigo="CtrlAplicacaoMedicamento"
              refresh={atualiza}
              parametros={{ idUsuario: usuarioLogado.id }}
              collumnsDateHour={[2, 3]}
              head={[
                'Atendimento',
                'Paciente',
                'Inclusão',
                'Aplicação',
                'Produto',
                'Dose',
                '',
              ]}
              line={(item) => [
                item[1]?.[1] || '',
                item[2][1],
                item[9],
                item[10],
                item[3][1],
                `${item[11]}${item[12]}`,
                '',
              ]}
              columnOptions={[
                {
                  alias: 12,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small" onClick={exclui(linhaOriginal)}>
                      {linhaOriginal[14] ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, idUsuario: usuarioLogado.id }} />
      )}
    </Programa>
  )
}

export default AplicacaoMedicamento
